/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-private-classes */

'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UIToolBar from 'UIComponents/nav/UIToolBar';
import UIToolBarGroup from 'UIComponents/nav/UIToolBarGroup';
import UILink from 'UIComponents/link/UILink';
import Big from 'UIComponents/elements/Big';
import UIModal from 'UIComponents/dialog/UIModal';
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullScreenContents = styled.div.withConfig({
  displayName: "EPFullScreenModal__FullScreenContents",
  componentId: "jpjh8n-0"
})(["height:100%;.fullscreen-header{border-bottom:2px ", " solid;position:relative;box-shadow:0px 2px 0px rgba(216,216,216,0.3);padding:16px 26px;.close-button{.private-icon{font-size:16px;}}}.modal-content{height:calc(100% - 74px);overflow-y:scroll;}"], GREAT_WHITE);
class EPFullScreenModal extends Component {
  constructor(props) {
    super(props);
    this.renderHeader = this.renderHeader.bind(this);
  }
  renderHeader() {
    const {
      headerButton,
      headerContent,
      onClose
    } = this.props;
    return /*#__PURE__*/_jsxs(UIToolBar, {
      use: "tabs",
      className: "fullscreen-header",
      children: [/*#__PURE__*/_jsx(UIToolBarGroup, {
        minWidth: "33%",
        children: /*#__PURE__*/_jsx(UIBackButton, {
          className: "close-button",
          children: /*#__PURE__*/_jsx(UILink, {
            "data-test-id": "preview-modal-close",
            className: "m-left-0",
            onClick: onClose,
            children: /*#__PURE__*/_jsx(Big, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "epFullScreenModal.back"
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(UIToolBarGroup, {
        children: headerContent
      }), /*#__PURE__*/_jsx(UIToolBarGroup, {
        minWidth: "33%",
        children: headerButton
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsx(UIModal, {
      use: "fullscreen",
      children: /*#__PURE__*/_jsxs(FullScreenContents, {
        children: [this.renderHeader(), /*#__PURE__*/_jsx("div", {
          className: "modal-content",
          children: this.props.children
        })]
      })
    });
  }
}
EPFullScreenModal.propTypes = {
  headerButton: PropTypes.node,
  headerContent: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
};
export default EPFullScreenModal;